import React from "react";
import { LoadingOutlined } from "@ant-design/icons";

function LoadingCom() {
  return (
    <div className="flex justify-center items-center m-10">
      <LoadingOutlined style={{ fontSize: 30, color: "orange" }} />
    </div>
  );
}

export default LoadingCom;
